import api from "@/lib/api";

const imageCache = new Map();
const thumbnailCache = new Map();

function getImageEntry(projectId, imageId) {
  const key = `${projectId}:${imageId}`;

  if (imageCache.has(key)) {
    return imageCache.get(key);
  }

  const entry = {
    blob: null,
    objectUrl: null,
    dataUrlPromise: null,
    promise: null,
  };

  entry.promise = api.get(
    `/projects/${projectId}/images/${imageId}`,
    { responseType: "blob" }
  ).then((response) => {
    entry.blob = response.data;
    entry.objectUrl = URL.createObjectURL(entry.blob);
    return entry;
  }).catch((error) => {
    imageCache.delete(key);
    throw error;
  });

  imageCache.set(key, entry);
  return entry;
}

export async function getProjectImageUrl(projectId, imageId) {
  if (!projectId || !imageId) return null;

  const entry = await getImageEntry(projectId, imageId).promise;
  return entry.objectUrl;
}


export async function getProjectThumbnailUrl(projectId, imageId) {
  if (!projectId || !imageId) return null;

  const key = `${projectId}:${imageId}`;
  let promise = thumbnailCache.get(key);

  if (!promise) {
    promise = api.get(
      `/projects/${projectId}/images/${imageId}/thumbnail`,
      { responseType: "blob" }
    ).then((response) => URL.createObjectURL(response.data))
      .catch((error) => {
        thumbnailCache.delete(key);
        throw error;
      });

    thumbnailCache.set(key, promise);
  }

  return promise;
}

export async function getProjectImageDataUrl(projectId, imageId) {
  if (!projectId || !imageId) return null;

  const entry = await getImageEntry(projectId, imageId).promise;

  if (!entry.dataUrlPromise) {
    entry.dataUrlPromise = new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("Gagal membaca gambar"));
      reader.readAsDataURL(entry.blob);
    });
  }

  return entry.dataUrlPromise;
}
